(() => {
  const TYPE_MAP = {
    pull: 'Pull / opening',
    collectie: 'Mijn collectie',
  };

  function countVisiblePosts(posts, filter) {
    if (filter === 'all') return posts.length;
    let count = 0;
    posts.forEach((post) => {
      if (post.dataset.type === filter) count += 1;
    });
    return count;
  }

  function applyFilter(section, filter) {
    const grid = section.querySelector('[data-community-grid]');
    const posts = section.querySelectorAll('.cc-community-post');
    const emptyState = section.querySelector('[data-community-empty]');
    const typeSelect = section.querySelector('[data-community-type-select]');
    const filters = section.querySelectorAll('.cc-community__filter');

    filters.forEach((btn) => {
      const isActive = btn.dataset.filter === filter;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (grid) {
      grid.dataset.activeFilter = filter;
    }

    posts.forEach((post) => {
      const show = filter === 'all' || post.dataset.type === filter;
      post.toggleAttribute('hidden', !show);
      post.classList.toggle('cc-community-post--hidden', !show);
    });

    const visible = countVisiblePosts(posts, filter);
    if (emptyState) {
      emptyState.hidden = visible > 0;
    }

    if (typeSelect && TYPE_MAP[filter]) {
      typeSelect.value = TYPE_MAP[filter];
    }
  }

  function formatReviewDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('nl-NL', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  function renderStars(rating) {
    const count = Math.max(0, Math.min(5, Number(rating) || 0));
    let html = '';
    for (let i = 1; i <= 5; i += 1) {
      html += `<span class="cc-community-post__star${i <= count ? ' is-filled' : ''}">★</span>`;
    }
    return html;
  }

  function normalizeReviewId(review, index) {
    const raw = review.uuid ?? review.id ?? review.review_id ?? index + 1;
    return String(raw);
  }

  function loadJudgeMeReviews(section) {
    const dataEl = section.querySelector('#cc-judgeme-reviews-data');
    if (!dataEl) return new Map();

    try {
      const reviews = JSON.parse(dataEl.textContent || '[]');
      const map = new Map();
      reviews.forEach((review, index) => {
        map.set(normalizeReviewId(review, index), review);
      });
      return map;
    } catch {
      return new Map();
    }
  }

  function initJudgeMeReviewModal(section) {
    const modal = section.querySelector('[data-judgeme-review-modal]');
    if (!modal) return null;

    const dialog = modal.querySelector('.cc-judgeme-review-modal__dialog');
    const reviewsById = loadJudgeMeReviews(section);
    let lastFocus = null;

    const fields = {
      avatar: modal.querySelector('[data-judgeme-modal-avatar]'),
      author: modal.querySelector('[data-judgeme-modal-author]'),
      date: modal.querySelector('[data-judgeme-modal-date]'),
      stars: modal.querySelector('[data-judgeme-modal-stars]'),
      title: modal.querySelector('[data-judgeme-modal-title]'),
      body: modal.querySelector('[data-judgeme-modal-body]'),
      tags: modal.querySelector('[data-judgeme-modal-tags]'),
      product: modal.querySelector('[data-judgeme-modal-product]'),
    };

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cc-judgeme-review-modal-open');
      if (window.location.hash.startsWith('#review-')) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      if (lastFocus) {
        lastFocus.focus({ preventScroll: true });
      }
    }

    function openModal(reviewId, trigger) {
      const review = reviewsById.get(String(reviewId));
      if (!review) return;

      lastFocus = trigger || document.activeElement;

      const author = review.reviewer_name || review.reviewer?.name || 'Klant';
      const initial = author.trim().charAt(0).toUpperCase() || 'K';
      const reviewDate = review.created_at || review.review_date || '';
      const rating = review.rating || 0;
      const title = review.title || 'Recensie';
      const body = review.body || '';
      const productTitle = review.product_title || '';
      const productUrl = review.product_url || '';
      const isShopReview = review.is_shop_review === true || !productUrl;

      fields.avatar.textContent = initial;
      fields.author.textContent = author;

      if (reviewDate) {
        fields.date.textContent = formatReviewDate(reviewDate);
        fields.date.setAttribute('datetime', reviewDate.slice(0, 10));
      } else {
        fields.date.textContent = 'Klantrecensie';
        fields.date.removeAttribute('datetime');
      }

      fields.stars.innerHTML = renderStars(rating);
      fields.stars.setAttribute('aria-label', `${rating} van 5 sterren`);
      fields.title.textContent = title;
      fields.body.textContent = body.replace(/<[^>]*>/g, '');

      const tagParts = ['<span class="cc-community-post__tag">Geverifieerd</span>'];
      if (productTitle) {
        const shortTag = productTitle.includes(':')
          ? productTitle.split(':').pop().trim().slice(0, 28)
          : productTitle.slice(0, 28);
        if (shortTag) {
          tagParts.push(`<span class="cc-community-post__tag">${shortTag}</span>`);
        }
      }
      fields.tags.innerHTML = tagParts.join('');

      if (!isShopReview && productUrl) {
        fields.product.href = productUrl;
        fields.product.hidden = false;
      } else {
        fields.product.hidden = true;
      }

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cc-judgeme-review-modal-open');
      history.replaceState(null, '', `#review-${reviewId}`);
      dialog.focus({ preventScroll: true });
    }

    section.querySelectorAll('[data-open-judgeme-review]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openModal(trigger.dataset.openJudgemeReview, trigger);
      });
    });

    modal.querySelectorAll('[data-judgeme-review-close]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    const hash = window.location.hash;
    if (hash.startsWith('#review-')) {
      const reviewId = hash.replace('#review-', '');
      window.setTimeout(() => openModal(reviewId), 0);
    }

    return { openModal, closeModal };
  }

  function initCommunitySection(section) {
    const filters = section.querySelectorAll('.cc-community__filter');

    filters.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const filter = btn.dataset.filter || 'all';
        applyFilter(section, filter);
      });
    });

    section.querySelectorAll('[data-scroll-to-form]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = section.querySelector('#deel-je-verhaal');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const nameInput = section.querySelector('[data-community-name]');
        if (nameInput) {
          window.setTimeout(() => nameInput.focus({ preventScroll: true }), 400);
        }
      });
    });

    section.querySelectorAll('[data-filter-jump]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const filter = link.dataset.filterJump;
        const filterBtn = section.querySelector(`.cc-community__filter[data-filter="${filter}"]`);
        if (filterBtn) {
          event.preventDefault();
          filterBtn.click();
        }
      });
    });

    initJudgeMeReviewModal(section);
    applyFilter(section, 'all');
  }

  function boot() {
    document.querySelectorAll('.cc-community').forEach(initCommunitySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
